"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

// TODO(alipianu): keep in sync with Figma (synced from https://www.figma.com/design/qcB5qVN7uKBBYHN49ihDE7/Slate-Icons?node-id=9321-692&m=dev)
/** @optimized using svgo:^3.0.2 */
export const Square = createSVGIcon(
  <path
    d="M19.99 0H4.01A4.01 4.01 0 0 0 0 4.01v15.98A4.01 4.01 0 0 0 4.01 24h15.98A4.01 4.01 0 0 0 24 19.99V4.01A4.01 4.01 0 0 0 19.99 0m-.353 18.37c0 .7-.567 1.267-1.267 1.267H5.63c-.7 0-1.267-.567-1.267-1.267V5.63c0-.7.567-1.267 1.267-1.267h12.74c.7 0 1.267.567 1.267 1.267zM9.454 15.258a.726.726 0 0 1-.726-.73V9.443c0-.403.323-.731.726-.731h5.094c.4 0 .726.326.726.731v5.084a.73.73 0 0 1-.726.73H9.454z"
    fill="currentColor"
  />,
  "Square",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    titleAccess: strictLocalize({
      id: "ervGoF",
      defaultMessage: "Square logo",
      description: { text: "The label for Square's company logo icon" },
    }),
  })
);
